<main
	[class.form-fields-sub-module]="formType === 'form-primary'"
	[class.form-fields-sub-module-modal]="formType === 'modal'"
	[class.form-fields-sub-module-table]="formType === 'form-secondary'"
>
	@if (callDynamicForm) {
		<ng-container
			*ngTemplateOutlet="dynamicFormData; context: { id: properties?.id }"
		></ng-container>
	}

	@if (!callDynamicForm) {
		<ng-container *ngTryFor="let field of properties?.fields">
			<ng-container *ngTryFor="let item of field">
				<ng-container *ngTemplateOutlet="titleSection; context: { dataField: item }"></ng-container>
			</ng-container>
			<div class="ff-row-form ovx-hidden">
				<ng-container *ngTryFor="let item of field">
					<ng-container
						*ngTemplateOutlet="fieldMultiplex; context: { dataField: item }"
					></ng-container>
				</ng-container>
				@if (field.length === 0) {
					<div class="h-32"></div>
				}
			</div>
		</ng-container>
	}
</main>
<ng-template let-field="dataField" #fieldMultiplex>
	@if (
		dynamicFormService.formControlStructure.fieldControl[field.entityKey]
			? dynamicFormService.formControlStructure.fieldControl[field.entityKey].visible
			: false
	) {
		<div [ngClass]="'ff-field-size-' + field.size" [class.ff-box-field]="!(field.size === 0)">
			@if (field.type === 'HIDDEN') {
				<lbca-input-hidden
					[label]="field.label"
					[defaultValue]="field.defaultValue"
				></lbca-input-hidden>
			}
			@if (field.type === 'TEXT') {
				<lbca-input-text
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[placeholder]="field.placeholder || ''"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					[fieldMetadata]="field"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="
						data && data[field.entityKey]
							? data[field.entityKey]
							: field.defaultValue
								? field.defaultValue
								: ''
					"
					[helperText]="field.helperText"
				></lbca-input-text>
			}
			@if (field.type === 'PROCESS_NUMBER') {
				<lbca-input-process-number
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					[fieldMetadata]="field"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="
						data && data[field.entityKey]
							? data[field.entityKey]
							: field.defaultValue
								? field.defaultValue
								: ''
					"
					[helperText]="field.helperText"
				></lbca-input-process-number>
			}
			@if (field.type === 'INPUT_REF') {
				<legalboxplus-input-reference
					[cardData]="cardInfo"
					[label]="field.label"
					[field]="field"
					[value]="data ? data[field.entityKey] : ''"
				></legalboxplus-input-reference>
			}
			@if (field.type === 'TEXT-CONDENSED') {
				<lbca-input-text-condensed
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-input-text-condensed>
			}
			@if (field.type === 'TEXTAREA') {
				<lbca-textarea
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					(errorState)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
					[rules]="field.rules"
				></lbca-textarea>
			}
			@if (field.type === 'DATE_TIME') {
				<lbca-date-time-picker
					[value]="data ? data[field.entityKey] : ''"
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[labelDate]="field.labelDate"
					[labelTime]="field.labelTime"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[helperText]="field.helperText"
					[rules]="field.rules"
					[disabledDateRules]="field.disabledDateRules"
				></lbca-date-time-picker>
			}
			@if (field.type === 'CALENDAR') {
				<lbca-date-picker
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
					[rules]="field.rules"
					[disabledDateRules]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							?.disabledDateRules || field.disabledDateRules
					"
				></lbca-date-picker>
			}
			@if (field.type === 'TIME') {
				<lbca-timepicker
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(errorState)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-timepicker>
			}
			@if (field.type === 'TREE_TABLE') {
				<lbca-tree-table
					[value]="data ? data[field.entityKey] : ''"
					[field]="field"
				></lbca-tree-table>
			}
			@if (
				field.auxEntity &&
				(field.auxEntity.entityUrl !== null || field.auxEntity.listOptions) &&
				field.type !== 'TREE_TABLE'
			) {
				<lbca-entity-fields
					[isOpen]="isOpen"
					[forceType]="field.type === 'LIST_REF' ? 'LIST_REF' : null"
					[label]="field.label"
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[field]="field"
					[cardData]="cardInfo"
					[controllData]="controllData"
					[dataFather]="field.childrenDependency ? field.childrenDependency.father : null"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[readOnly]="field.readOnly"
					[require]="field.required"
					[flowId]="flowId"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(errorApi)="erroApi($event)"
					[value]="data ? data[field.entityKey] : ''"
					[defaultValue]="field.defaultValue"
					(feedback)="setFeedbackEmmiter($event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					(startValue)="subFormModuleInstance(field.entityKey, 'startValue', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(callDynamicForm)="setDynamicForm($event)"
					[initialized]="initialized"
					[helperText]="field.helperText"
				></lbca-entity-fields>
			}
			@if (field.type === 'SELECT_TREE_CONDENSED') {
				<lbca-select-tree-condensed
					[field]="field"
					[label]="field.label"
					[cardData]="cardInfo"
					[value]="data ? data[field.entityKey] : ''"
				></lbca-select-tree-condensed>
			}
			@if (
				field.type === 'SELECT_TREE' &&
				!dynamicFormService.formControlStructure.fieldControl[field.entityKey].locked
			) {
				<lbca-select-tree
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[field]="field"
					[label]="field.label"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[cardData]="cardInfo"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					(changeSecundaryValue)="handlerChangeSecundaryValue(field, $event)"
					(changeProperties)="subFormModuleInstance(field.entityKey, 'properties', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-select-tree>
			}
			@if (field.type === 'GRIDBOX') {
				<lbca-gridbox
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					[field]="field"
					[template]="field.template"
					[configuration]="field.configuration"
					[label]="field.label"
					[labeled]="true"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[dynamicFormService]="dynamicFormService"
					[gridFormModuleInstance]="gridFormModuleInstance"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-gridbox>
			}
			@if (field.type === 'GRIDBOX_UNIQUE') {
				<lbca-gridbox-unique
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[field]="field"
					[cardData]="cardInfo"
					[configuration]="field.configuration"
					[label]="field.label"
					[labeled]="true"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-gridbox-unique>
			}
			@if (field.type === 'LIST_ADDRESS') {
				<lbca-address-list
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					(validateCallback)="setValidationAddressCallback($event, field.entityKey)"
					[require]="field.required"
					[label]="field.label"
					[displayFields]="field.displayFields"
					[labeled]="true"
				></lbca-address-list>
			}
			@if (field.type === 'TABLE_LIST') {
				<lbca-table-list
					[cardData]="cardInfo"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[field]="field"
					[dataAttr]="dataAttr"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[value]="data ? data[field.entityKey] : ''"
				></lbca-table-list>
			}
			@if (field.type === 'OAB') {
				<lbca-oab
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					(validateCallback)="setValidationAddressCallback($event, field.entityKey)"
					[cardData]="cardInfo"
					[require]="field.required"
					[label]="field.label"
					[labeled]="true"
				></lbca-oab>
			}
			@if (field.type === 'COMMENT_FORUM') {
				<lbca-comment-forum
					(focusState)="focusState($event, data ? data[field.entityKey] : '', field.entityKey)"
					[label]="field.label"
					[cardData]="cardInfo"
					[contextValue]="context"
					[configuration]="field"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[dataAttr]="dataAttr"
					(errorState)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[helperText]="field.helperText"
					[value]="data"
				>
					>
				</lbca-comment-forum>
			}
			@if (field.type === 'MESSAGE') {
				<lbca-message-field [label]="field.label" [color]="field.color"></lbca-message-field>
			}
			@if (field.type === 'FILE_UPLOAD') {
				<lbca-sub-module-file-upload
					[idEntity]="field.entityKey"
					[value]="data ? data[field.entityKey] : ''"
					[label]="field.label"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					[flowId]="flowId"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[field.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						field.disabled ||
						(field.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[properties]="field"
					(saveValue)="saveUpload($event)"
					(errorApi)="erroApi($event)"
					(validateCallback)="setValidationAddressCallback($event, field.entityKey)"
				></lbca-sub-module-file-upload>
			}
			@if (field.type === 'FILE_FROM_PROCESS') {
				<lbca-file-from-process
					[label]="field.label"
					[buttonLabel]="field.buttonLabel"
					[value]="data ? data[field.entityKey] : ''"
					[flowId]="flowId"
					[context]="field.context"
					[cardData]="cardInfo"
					[properties]="field"
					(saveValue)="saveUpload($event)"
					(validateCallback)="setValidationAddressCallback($event, field.entityKey)"
				>
					>
				</lbca-file-from-process>
			}
			@if (
				dynamicFormService.formControlStructure.fieldControl[field.entityKey].visible &&
				dynamicFormService.formControlStructure.fieldControl[field.entityKey].locked &&
				!dynamicFormService.formControlStructure.fieldControl[field.entityKey].unlocked
			) {
				<ng-container class="mt-5 pt-5">
					<div class="dyc-dependency-module">
						<div class="ff-row-form mb-15">
							<p class="text-gray-900 text-xs">{{ field.label }}</p>
						</div>
						<div class="dyc-msg-container">
							<div class="flex flex-col">
								<div class="dyc-text-msg">
									{{ dynamicFormService.formControlStructure.fieldControl[field.entityKey].msg }}
								</div>
							</div>
							<div class="emojis-shackle icon-box ml-16"></div>
						</div>
					</div>
				</ng-container>
			}
		</div>
	}
</ng-template>

<ng-template let-field="dataField" #titleSection>
	@if (field.type === 'SECTION_LABEL') {
		<div class="ff-row-form">
			<header class="mt-32 pl-16 pr-16 w-full">
				<section class="flex jc-center flex-col w-full relative">
					<div class="d-inline-flex items-center">
						<p class="text-gray-900 text-xs ml--12">{{ field.label }}</p>
					</div>
				</section>
			</header>
		</div>
	}
</ng-template>
